import { createMachine } from 'xstate';
import { useMachine } from '@xstate/react';
import { VerifiedIcon } from '@/components/icons/product/verified-icon';
import SquaredBox from '@/components/ui/squared-box';
import { KitIcon } from '@/components/icons/product/kit-icon';
import { AddPromotionalPackToCartButton } from '../../add-to-cart/add-promotional-pack-to-cart';
import { useProductPromotionalPack } from '../../add-to-cart/add-promotional-pack-to-cart/useProductPromotionalPack';
import { ISearchProduct } from '@/types';

function DiscountItemSelection({ product }: Readonly<{ product: ISearchProduct }>) {
  const { promotional_pack_details } = useProductPromotionalPack(product);

  return (
    <div className="w-full flex items-center justify-between">
      <span className="text-gray-200 text-lg">
        {promotional_pack_details?.promotional_pack_quantity} Unid. cada por:
      </span>
      <div className="flex">
        <AddPromotionalPackToCartButton product={product} />
      </div>
    </div>
  );
}

function BoxProductSelection({ product }: Readonly<{ product: ISearchProduct }>) {
  return (
    <SquaredBox>
      <SquaredBox.Header
        title="Leve mais por menos"
        subtitle="Preços exclusivos Qualidoc"
        icon={<KitIcon />}
        className="bg-[#E8F2FB]"
        titleStyle="text-accent"
      />
      <SquaredBox.Content className="justify-start mt-6 gap-4">
        <DiscountItemSelection product={product} />
      </SquaredBox.Content>
    </SquaredBox>
  );
}

function BoxConfirmation() {
  return (
    <SquaredBox>
      <SquaredBox.Header
        title="Produto Indisponível"
        icon={<VerifiedIcon />}
        className="bg-[#E8F2FB]"
        titleStyle="text-accent font-semibold"
      />
      <SquaredBox.Content className="items-center">
        <p className="py-6 w-full">Beneficio Aplicado</p>
      </SquaredBox.Content>
    </SquaredBox>
  );
}

const productKitMachine = createMachine({
  id: 'productKit',
  initial: 'selection',
  states: {
    selection: { on: { NEXT: 'confirmation' } },
    confirmation: { on: { BACK: 'selection' } },
  },
});

function RenderFormSteps({ product }: Readonly<{ product: ISearchProduct }>) {
  const [state, send] = useMachine(productKitMachine);

  const handleConfirm = () => {
    send({ type: 'BACK' });
  };

  return (
    <div className="w-full">
      {state.matches('selection') && <BoxProductSelection product={product} />}

      {state.matches('confirmation') && (
        <BoxConfirmation handleConfirm={handleConfirm} />
      )}
    </div>
  );
}

export default function ProductKits({ product }: Readonly<{ product: ISearchProduct }>) {
  return <RenderFormSteps product={product} />;
}
